import { Rect } from './Rect';
import { Vector2 } from './Vector2';

export class GlyphCache {
  readonly rect: Rect;
  readonly offset: Vector2;

  constructor(rect: Rect, offset: Vector2) {
    this.rect = rect;
    this.offset = offset;
  }
}
